import { defineFcm } from '../shared/factory';

// FIXME should probably be a JSON FCM
export const FCM_ADVOCATES_PSF_TASKS = defineFcm('advocates_psf_tasks').asString().withDefault(undefined).toConfig();
